module.exports = __webpack_public_path__ + "img/restrict-icon.ffc3023b.svg";